import { useNavigate } from 'react-router-dom';
import { useMe } from '@/Hooks';

/**
 * A hook that provides authentication protection for actions
 * Redirects to login page if user is not authenticated
 */
const useAuthProtection = () => {
  const navigate = useNavigate();
  const { me } = useMe();

  /**
   * Checks if user is authenticated and redirects to login if not
   * @returns boolean - Whether the user is authenticated
   */
  const requireAuth = (): boolean => {
    if (!me) {
      navigate('/login');
      return false;
    }
    
    return true;
  };

  /**
   * Executes a callback function only if the user is authenticated
   * @param callback - Function to execute if authenticated
   */
  const withAuth = <T extends any[]>(
    callback: (...args: T) => void | Promise<void>
  ) => {
    return (...args: T) => {
      if (requireAuth()) {
        return callback(...args);
      }
    };
  };

  return {
    requireAuth,
    withAuth,
    isAuthenticated: !!me
  };
};

export default useAuthProtection;
